import React from 'react';
import AutocompleteNext from '@ott/autocomplete-next-deprecated';
import AirportIcon from '@ott/icon-airport';
import MapPointIcon from '@ott/map-point-icon';
import RailwaysIcon from '@ott/icon-railways';
import HotelsIcon from '@ott/icon-hotels';

import styles from './GeoAutocompleteNext.scss';

export default function GeoAutocompleteNext(props) {
  return (
    <AutocompleteNext
      revertChanges={true}
      {...props}
      triggerProps={{
        withTitle: false,
        autoSelectOnFocus: true,
        OverlayInfoRenderer: TriggerOverlayInfo,
        ...props.triggerProps,
        maskTextRenderer,
        spellCheck: false,
      }}
      overlayProps={{
        ...props.overlayProps,
        optionRendererProps: {
          OptionIconRenderer: OptionIcon,
          ...props.overlayProps.optionRendererProps,
        },
      }}
    />
  );
}

function maskTextRenderer(props) {
  const { value = '', option, withFullMask, shouldRenderAirportCity } = props;

  if (!value || !option) {
    return null;
  }

  let text = option.name;

  if (withFullMask && option.country && option.text) {
    return `${option.text}, ${
      shouldRenderAirportCity &&
      option.type === 'airport' &&
      option.city &&
      option.city !== option.name
        ? option.city + ', '
        : ''
    }${option.country}`;
  }

  if (
    text &&
    option.city &&
    option.city !== option.name &&
    option.type === 'airport' &&
    shouldRenderAirportCity
  ) {
    text += `, ${option.city}`;
  }

  if (text && option.country) {
    text += `, ${option.country}`;
  }
  if (text && option.description) {
    text += `, ${option.description}`;
  }

  return text;
}

function TriggerOverlayInfo({ option, isLoading }) {
  if (option && !isLoading) {
    return <div className={styles.iata}>{option.code}</div>;
  }

  return null;
}

function OptionIcon({ option }) {
  if (option && option.type === 'airport') {
    return <AirportIcon className={styles.AirportIcon} />;
  }

  if (option && option.isRailwayStation) {
    return <RailwaysIcon className={styles.RailwaysIcon} w={24} h={24} />;
  }

  if (option && option.type === 'hotel') {
    return <HotelsIcon className={styles.HotelsIcon} />;
  }

  return <MapPointIcon className={styles.MapPointIcon} />;
}

GeoAutocompleteNext.displayName = 'GeoAutocompleteNext';

GeoAutocompleteNext.defaultProps = {
  ...AutocompleteNext.defaultProps,
};

GeoAutocompleteNext.propTypes = {
  ...AutocompleteNext.propTypes,
};
